var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mx-auto mb-4 w-10 max-w-full",attrs:{"src":require("@/assets/images/AEM2.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }